import { useCallback } from 'react';
import WOW from 'wowjs';

/**
 * Custom hook to initialize WOW.js for triggering scroll-based animations.
 * 
 * @returns {Object} An object containing the `initWow` method.
 */
const useWow = () => {
    /**
     * Initializes the WOW.js animation library with predefined settings.
     * Use inside a `useEffect` or appropriate lifecycle event.
     */
    const initWow = useCallback(() => {
        const wowInstance = new WOW.WOW({
            boxClass: "wow",
            animateClass: "animated",
            offset: 0,
            live: false,
            scrollContainer: null
        });
        wowInstance.init();
    }, []);
    
    return { initWow }
}

export default useWow;